// src/pages/PureMadness.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import PureMadnessSection from "../components/PureMadnessSection";
import Footer from "../components/Common/footer/Footer";
import "../styles/Pages.css";

const PureMadness = () => {
    return (
        <div className="page-shell shop-page">
            <Navigation />

            {/* ── Dark VIP Hero ── */}
            <section className="shop-hero" style={{ background: "#030303", borderBottom: "1px solid rgba(212, 175, 55, 0.15)", padding: "70px 0 50px" }}>
                <div className="container" style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                    <span className="page-hero-eyebrow" style={{ color: "#d4af37" }}>Exclusive Collection</span>
                    <h1 style={{
                        fontFamily: "var(--font-display)",
                        fontSize: "clamp(2rem, 5vw, 4rem)",
                        fontWeight: 400,
                        letterSpacing: "6px",
                        textTransform: "uppercase",
                        color: "#fff",
                        margin: "10px 0 12px",
                        textShadow: "0 0 25px rgba(212,175,55,0.15)"
                    }}>
                        Pure Madness
                    </h1>
                    <p style={{ color: "rgba(255,255,255,0.5)", fontFamily: "'Montserrat', sans-serif", fontSize: "0.75rem", letterSpacing: "4px", textTransform: "uppercase" }}>
                        100% Raw Cambodian Hair · Pure In Every Strand
                    </p>
                    <div style={{ width: 48, height: 1, background: "var(--gold)", opacity: 0.8, margin: "25px auto 0" }} />
                </div>
            </section>

            {/* ── Editorial Intro Section ── */}
            <section style={{ backgroundColor: "#0a0a0a", padding: "60px 20px 20px", textAlign: "center" }}>
                <div className="container" style={{ maxWidth: "800px", margin: "0 auto" }}>
                    <div style={{ color: "#a0aec0", fontFamily: "'Montserrat', sans-serif", fontSize: "0.95rem", lineHeight: "1.9", fontWeight: 300 }}>
                        <p style={{ marginBottom: "20px" }}>
                            Our Raw Cambodian Collection was created for the girls who understand that real luxury is found in quality, longevity, and purity. Every strand is carefully sourced and intentionally selected to maintain its natural softness, fullness, and movement.
                        </p>
                        <p style={{ marginBottom: "20px" }}>
                            With proper care, Pure Madness is designed to last 3+ years — because good hair shouldn’t just look beautiful for a moment, it should remain part of your story over time.
                        </p>
                        <p style={{ marginBottom: "0" }}>
                            From the richness of each bundle to the effortless blend and versatility, this collection represents hair in its purest form. Carefully detailed. Authentically luxurious. Made for the madness that comes with truly loving your hair.
                        </p>
                    </div>
                </div>
            </section>

            <PureMadnessSection />
            <Footer />
        </div>
    );
};

export default PureMadness;